// initial state
const state = {
  options: {
    type: [
      {label: '检查', value: 4, desc: '(常规检查)'},
      {label: '理货', value: 0, desc: '(理货盘库)', disabledForCreate: true, deprecated: true},
      // {label: '招聘', value: 1},
      // {label: '促销', value: 2},
      // {label: '派发', value: 3},
      // {label: '数据', value: 5},
      {label: '悬赏', value: 6, desc: '(销售)', disabledForCreate: true, deprecated: true},
      // {label: '审核', value: 7},
      {label: '录入', value: 8, desc: '(考试)', disabledForCreate: true},
      {label: '其他', value: 10, desc: '(录入)', disabledForCreate: true, deprecated: true},
      // {label: '体验', value: 11},
      // {label: '互动', value: 12},
      // {label: '分享', value: 13},
      // {label: '扫码', value: 14},
      {label: '活动', value: 15, desc: '', disabledForCreate: true, deprecated: true},
      {label: '考试', value: 16},
      {label: '推广', value: 18, desc: '(无法归入上述任一类型)', disabledForCreate: true, deprecated: true},
      {label: '直播', value: 19, disabledForCreate: true, deprecated: true},
      {label: '门店验证', value: 20},
      {label: '爱数智', value: 21, desc: '', disabledForCreate: true},
      {label: '米单', value: 127},
      {label: '信息流', value: 22},
      {label: '宴席', value: 23, disabledForCreate: true},
      {label: '理货', value: 24, desc: ''},
      {label: '盘库', value: 25, desc: ''},
      {label: '人员', value: 26, desc: ''},
      {label: '神访', value: 27, desc: ''},
      {label: '体验', value: 28, desc: ''},
      {label: '推广', value: 29, desc: ''},
      {label: '宴席(2)', value: 30, disabledForCreate: true},
    ],
    allType: [
      {label: '理货', value: 0},
      {label: '招聘', value: 1},
      {label: '促销', value: 2},
      {label: '派发', value: 3},
      {label: '检查', value: 4},
      {label: '数据', value: 5},
      {label: '悬赏', value: 6},
      {label: '审核', value: 7},
      {label: '录入', value: 8},
      {label: '其他', value: 10},
      {label: '体验', value: 11},
      {label: '互动', value: 12},
      {label: '分享', value: 13},
      {label: '扫码', value: 14},
      {label: '活动', value: 15},
      {label: '考试', value: 16},
      {label: 'Teke', value: 17},
      {label: '推广', value: 18},
      {label: '直播', value: 19},
      {label: '检查-门店验证', value: 20},
      {label: '爱数智', value: 21},
      {label: '米单', value: 127},
      {label: '信息流', value: 22},
      {label: '宴席', value: 23},
      {label: '理货', value: 24},
      {label: '盘库', value: 25},
      {label: '人员', value: 26},
      {label: '神访', value: 27},
      {label: '体验', value: 28},
      {label: '推广', value: 29},
      {label: '宴席(2)', value: 30},
    ],
    status: [
      {label: '订单新创建', value: 0},
      {label: '等待抢单', value: 1},
      {label: '已抢单', value: 2},
      {label: '进行中', value: 3},
      {label: '待审核', value: 4},
      {label: '管理员复审', value: 40},
      {label: '审核通过', value: 5},
      {label: '已关闭', value: -1},
      {label: '审核未通过', value: -2},
      {label: '已删除', value: -3},
      {label: '已下线', value: 10},
      {label: '申诉中', value: 20},
    ],
    taskstatus: [
      {label: '订单新创建', value: 0},
      {label: '等待抢单', value: 1},
      {label: '已抢单', value: 2},
      {label: '已关闭', value: -1},
      {label: '已下线', value: 10},
    ],
    orderstatus: [
      {label: '已抢单', value: 2},
      {label: '进行中', value: 3},
      {label: '待审核', value: 4},
      {label: '管理员复审', value: 40},
      {label: '审核通过', value: 5},
      {label: '已关闭', value: -1},
      {label: '审核未通过', value: -2},
      // {label: '已下线', value: 10},
      {label: '申诉中', value: 20},
    ],
    cstaskstatus: [
      {label: '未创建', value: 0},
      {label: '已创建', value: 1},
      {label: '冲突', value: 2},
      {label: '通过', value: 3},
      {label: '未通过', value: 4},
      {label: '无照片', value: 5},
      {label: '复核通过', value: 6},
      {label: '复核未通过', value: 7},

    ],
    taskmarketareaid: [
      {label: '进口区', value: 1},
      {label: '休食区', value: 2},
      {label: '乳品区', value: 3},
      {label: '调料区', value: 4},
      {label: '冻品区', value: 5},
      {label: '饮料区', value: 6},
      {label: '粮油区', value: 7},
      {label: '纸品区', value: 8},
      {label: '日化区', value: 9},
      {label: '育婴区', value: 10},
      {label: '散货区', value: 11},
      {label: '百货区', value: 12},
      {label: '服装区', value: 13},
      {label: '鞋帽区', value: 14},
      {label: '生鲜区', value: 15},
      {label: '果蔬区', value: 16},
      {label: '酒水区', value: 17},
      {label: '其他区', value: 18},
      {label: '全卖场', value: 19},
    ],
    locked: [
      {label: '锁定', value: 1},
      {label: '未锁定', value: 10},
    ],
    cacheuploadstatus: [
      {label: '任务直接上传', value: 0},
      {label: '任务缓存上传开始', value: 10},
      {label: '任务缓存上传结束', value: 20},
    ],
    gpsCheck: [
      {label: '验证', value: 1},
      {label: '不验证', value: 0},
    ],
    priority: [
      {label: '是', value: 1},
      {label: '否', value: 0},
    ],
    nearby: [
      {label: '准许', value: 1},
      {label: '不准许', value: 0},
    ],
    inhouseprior: [
      {label: '优先', value: 1},
      {label: '不优先', value: 0},
    ],
    superuserprior: [
      {label: '优先', value: 1},
      {label: '不优先', value: 0},
    ],
    multitimes: [
      {label: '允许', value: 1},
      {label: '不允许', value: 0},
    ],
    rejectuserrepeat: [
      {label: '允许', value: 1},
      {label: '不允许', value: 0},
    ],
    rejecttaskrepeat: [
      {label: '允许', value: 1},
      {label: '不允许', value: 0},
    ],
    ostype: [
      {label: '全部', value: 0},
      {label: 'Android平台', value: 10},
      {label: 'iOS平台', value: 20},
    ],
    platformtype: [
      {label: '全选', value: 9},
      {label: '爱零工', value: 0},
      {label: '查理宝', value: 8},
    ],
    onlynearby: [
      {label: '全部位置', value: 0},
      {label: '仅周边赚', value: 1},
    ],
    isInAudit: [
      {label: '审核中', value: true},
      {label: '未审核', value: false},
    ],
    allow_coupon: [
      {label: '允许', value: 1},
      {label: '不允许', value: 0},
    ],
    use_servercache: [
      {label: '开启', value: 1},
      {label: '关闭', value: 0},
    ],
    personface_verify: [
      {label: '开启', value: 1},
      {label: '关闭', value: 0},
    ],
    face_verified: [
      {label: '未验证', value: 0},
      {label: '通过', value: 1},
      {label: '不通过', value: 2},
    ],
    addto_taskgroup_target_num: [
      {label: '是', value: 1},
      {label: '否', value: 0},
    ],
    app_type_list: [
      {label: '爱零工', value: 1},
      {label: '查理宝', value: 2},
    ]
  },
}

// getters
const getters = {
  getSortedTaskTypes: (state) => {
    const taskTypes = _.cloneDeep(state.options.type)
    return taskTypes.sort((a, b) => {
      return (a.deprecated ? 1 : 0) - (b.deprecated ? 1 : 0)
    }).map(item => {
      return {...item, label: item.deprecated ? `${item.label}(已弃用)` : item.label}
    })
  }
}

// actions
const actions = {}

// mutations
const mutations = {}

export const order = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/order/order.store.js